import React from 'react';
import EmptyCell from './EmptyCell';

export default value => {
    if (value === null || value === false) {
        return <EmptyCell />;
    }

    return <div style={{ textAlign: 'center' }}>&#10003;</div>;
};
